import '../../styles/pages/article.scss';
import '../components/reed-more-slider';
import '../components/article-image-slider';
import Splide from '@splidejs/splide';

import generateTabs from '../components/generateTabs';
import '../components/article-categories-slider';
import '../components/copy-to-clipboard';

generateTabs('sidebar-popular', { isLoadMore: false });

const readMoreSliderPlaceholder = document.querySelector('.read-more-slider-placeholder');
const actualItemsPlaceholder = document.querySelector('.actual__items');
const sidebarsPlaceholder = document.querySelectorAll('.sidebar-popular-tab-content');
const getData = async () => {
  let url = `/${window.postData.lang === 'ru' ? 'ru/' : ''}load-post-additional-data/?postId=${window.postData.id}&theme=${window.postData.theme}`;


  try {
    const response = await fetch(url);
    let html;
    if (response.ok) {
      html = await response.text();
    }
    const data = html.split('$*');
    if (readMoreSliderPlaceholder) {
      readMoreSliderPlaceholder.innerHTML = data[0];
    }

    const foundSlider = document.querySelector('.read-more__slider-big');
    foundSlider && new Splide(foundSlider, {
      gap: 24,
      pagination: false,
      arrows: true,
      autoWidth: true,
      breakpoints: {
        768: {
          arrows: false,
        }
      }
    }).mount();

    if (actualItemsPlaceholder) {
      actualItemsPlaceholder.innerHTML = data[1];
    }
    if (sidebarsPlaceholder.length >= 1) {
      if (sidebarsPlaceholder[1])
        sidebarsPlaceholder[1].innerHTML = data[2];
      if (sidebarsPlaceholder[2])
        sidebarsPlaceholder[2].innerHTML = data[3];
      if (sidebarsPlaceholder[3])
        sidebarsPlaceholder[3].innerHTML = data[4];
    }

    // TODO: This code is repeated in base.html
    readMoreSliderPlaceholder.querySelectorAll('img').forEach(itm => itm.hasAttribute("data-src") && itm.classList.add('lazy'));
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }

  } catch (error) {
    console.log(error);
  }
}

if (window.postData) {
  window.addEventListener('load', getData);
}

const sidebars = document.querySelector('.sidebars')
let isSidebarsFixed = sidebars?.style.position !== 'relative';
const handleStickySidebars = () => {
  const mainImage = document.querySelector('.content__main-image img');
  const currentScrollPos = mainImage.getBoundingClientRect().bottom;
  if (sidebars) {
    if (currentScrollPos <= 20) {
      sidebars.style.position = 'relative';

      // 205.8px - header+breadcrums height, 20px - top property of sidebars
      if (!isSidebarsFixed) {
        isSidebarsFixed = true;
        sidebars.style.top = `${window.scrollY - (205.8 - 20)}px`;
      }

    } else {
      isSidebarsFixed = false;
      sidebars.style.position = 'sticky';
      sidebars.style.top = '20px';
    }
  }

}

window.addEventListener('scroll', handleStickySidebars)